/* Copia a lista em formato de tabela, pronto para colar no Excel ou no WhatsApp. */
import { dataBR, dias, toast, copiarTexto } from "../util.js";
import { S, visiveis } from "../estado.js";
import { MAPA } from "../dados/especies.js";
import { ETAPAS, DOCS } from "../dados/etapas.js";

export function copiarTabela(){
  const lista=visiveis(MAPA).slice().sort((a,b)=>String(a.entrada||"").localeCompare(String(b.entrada||"")));
  if(!lista.length){ toast("Nada para copiar"); return; }
  const cab=["Cliente"]; if(S.souAdmin) cab.push("Captador");
  cab.push("Data de entrada","Dias","Codigo","Caso","Doc enviado","Anexos","Situacao","Observacao");
  const l=[cab];
  lista.forEach(c=>{
    const et=ETAPAS.find(e=>e.id===c.etapa)||ETAPAS[0];
    const linha=[c.cliente]; if(S.souAdmin) linha.push(c.captador||"");
    linha.push(dataBR(c.entrada),dias(c.entrada)??"",c.codigo||"",MAPA[c.codigo]?.nome||"",
      (DOCS[c.doc]||DOCS.nao).rot.replace("Doc ",""),(c.anexos||[]).length,et.nome,c.obs||"");
    l.push(linha);
  });
  const txt=l.map(r=>r.map(v=>String(v).replace(/\t/g," ")).join("\t")).join("\n");
  copiarTexto(txt).then(ok=>toast(ok?"Tabela copiada":"Não deu para copiar"));
}
